import { PhoneField as Phone } from '@calendly/form/raw';
import { I18n } from '@calendly/i18n';
import { isSupportedCountry } from '@calendly/telephone-tools';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useCallback, useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { countryCodeSelector } from 'selectors/current_user';
import { CodeButtons } from './code_buttons';
import { SMSVerification } from './sms_verification';
import { usePhoneNumberStatus } from './use_phone_number_status';
const customPhoneIsPhoneCss = "czz6ted";
const customPhoneCss = "c8scp7c";
const CustomPhone = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Phone ref={ref} {...props} className={classNames(customPhoneCss, {
    [customPhoneIsPhoneCss]: isPhone
  }, props.className)} />;
});
const phoneContainerIsPhoneCss = "p24lozx";
const phoneContainerCss = "pen2280";
const PhoneContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(phoneContainerCss, {
    [phoneContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const sMSWarningCss = "s11uotg4";
const SMSWarning = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sMSWarningCss, props.className)} />;
});
const warningBadgeCss = "w1h8jrrc";
const WarningBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(warningBadgeCss, props.className)} />;
});
export const PhoneNumberField = ({
  phoneNumber,
  onChange,
  ownerId
}) => {
  const defaultCountryCode = useSelector(countryCodeSelector) || '';
  const [countryCode, setCountryCode] = useState(defaultCountryCode);
  const [phoneNumberValid, setPhoneNumberValid] = useState(false);
  const showCountryNotSupported = phoneNumberValid && !isSupportedCountry(countryCode);
  usePhoneNumberStatus(phoneNumber);
  const handlePhoneNumberChange = useCallback(({
    countryCode: newCountryCode,
    isValid,
    value
  }) => {
    setPhoneNumberValid(isValid);
    setCountryCode(newCountryCode ? newCountryCode.toUpperCase() : '');
    onChange(value);
  }, [onChange]);
  return <>
      <PhoneContainer>
        <CustomPhone name="phone_number" placeholder={I18n.t('publisher.workflows.actions.sms.enter_number')} number={phoneNumber} onChange={handlePhoneNumberChange} countryCode={defaultCountryCode} numberFormat="E164" />
        <CodeButtons phoneNumber={phoneNumber} ownerId={ownerId} phoneNumberValid={phoneNumberValid} />
      </PhoneContainer>
      {showCountryNotSupported && <SMSWarning>
          <WarningBadge>!</WarningBadge>
          {' '}
          {I18n.t(`publisher.workflows.actions.sms.country_not_supported.${countryCode.toLowerCase()}`)}
        </SMSWarning>}
      <SMSVerification phoneNumber={phoneNumber} ownerId={ownerId} />
    </>;
};

require("./component.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./component.js");